import React from 'react';
import './SearchEmptyState.sass';

type SearchEmptyStateProps = {
  title: string;
  subtitle: string;
};

const IconMagnifyingGlass = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 20 21"
    fill="none"
    className="search-empty-state__icon"
  >
    <path
      d="M9.0625 15.875C12.6869 15.875 15.625 12.9369 15.625 9.3125C15.625 5.68813 12.6869 2.75 9.0625 2.75C5.43813 2.75 2.5 5.68813 2.5 9.3125C2.5 12.9369 5.43813 15.875 9.0625 15.875Z"
      stroke="#8A94A8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7031 13.9531L17.5 17.75"
      stroke="#8A94A8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchEmptyState: React.FC<SearchEmptyStateProps> = ({ title, subtitle }) => (
  <div className="search-empty-state">
    <IconMagnifyingGlass />
    <div className="search-empty-state__text">
      <div className="search-empty-state__title">{title}</div>
      <div className="search-empty-state__subtitle">{subtitle}</div>
    </div>
  </div>
);

export default SearchEmptyState;
